import { render, staticRenderFns } from "./roleUserView.vue?vue&type=template&id=0610d352&scoped=true&"
import script from "./roleUserView.vue?vue&type=script&lang=js&"
export * from "./roleUserView.vue?vue&type=script&lang=js&"
import style0 from "./roleUserView.vue?vue&type=style&index=0&id=0610d352&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0610d352",
  null
  
)

export default component.exports